/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListGroups200ResponseItemsInnerAllOfCompaniesInner } from './ListGroups200ResponseItemsInnerAllOfCompaniesInner';
import {
    ListGroups200ResponseItemsInnerAllOfCompaniesInnerFromJSON,
    ListGroups200ResponseItemsInnerAllOfCompaniesInnerFromJSONTyped,
    ListGroups200ResponseItemsInnerAllOfCompaniesInnerToJSON,
    ListGroups200ResponseItemsInnerAllOfCompaniesInnerToJSONTyped,
} from './ListGroups200ResponseItemsInnerAllOfCompaniesInner';

/**
 * 
 * @export
 * @interface ListGroups200ResponseItemsInner
 */
export interface ListGroups200ResponseItemsInner {
    /**
     * PG名 半角英数のみ・スペース不可
     * @type {string}
     * @memberof ListGroups200ResponseItemsInner
     */
    paymentGroupName?: string;
    /**
     * 上位グループコード
     * @type {string}
     * @memberof ListGroups200ResponseItemsInner
     */
    organizationCode?: string;
    /**
     * 会社名 支払通知書の宛名用
     * @type {string}
     * @memberof ListGroups200ResponseItemsInner
     */
    companyName?: string;
    /**
     * インボイス番号 T+13桁数字固定
     * @type {string}
     * @memberof ListGroups200ResponseItemsInner
     */
    invoiceNo?: string;
    /**
     * 担当者名 支払通知書の宛名用
     * @type {string}
     * @memberof ListGroups200ResponseItemsInner
     */
    addressName?: string;
    /**
     * 銀行名 100文字以内
     * @type {string}
     * @memberof ListGroups200ResponseItemsInner
     */
    bankName?: string;
    /**
     * 支店名
     * @type {string}
     * @memberof ListGroups200ResponseItemsInner
     */
    branchName?: string;
    /**
     * 支店番号 3桁数字
     * @type {string}
     * @memberof ListGroups200ResponseItemsInner
     */
    branchNum?: string;
    /**
     * 普通・当座
     * @type {number}
     * @memberof ListGroups200ResponseItemsInner
     */
    bankAccountType?: ListGroups200ResponseItemsInnerBankAccountTypeEnum;
    /**
     * 口座番号 7桁数字
     * @type {string}
     * @memberof ListGroups200ResponseItemsInner
     */
    bankAccountNumber?: string;
    /**
     * 口座名義
     * @type {string}
     * @memberof ListGroups200ResponseItemsInner
     */
    bankAccountName?: string;
    /**
     * メール通知先 メールアドレス最大3件まで指定
     * @type {Array<string>}
     * @memberof ListGroups200ResponseItemsInner
     */
    notificationMails?: Array<string>;
    /**
     * 閲覧権限ユーザ メールアドレス最大3件まで指定
     * @type {Array<string>}
     * @memberof ListGroups200ResponseItemsInner
     */
    accessMails?: Array<string>;
    /**
     * メモ 最大100文字
     * @type {string}
     * @memberof ListGroups200ResponseItemsInner
     */
    note?: string;
    /**
     * PGID
     * @type {number}
     * @memberof ListGroups200ResponseItemsInner
     */
    id: number;
    /**
     * 閲覧権限ユーザ
     * @type {Array<string>}
     * @memberof ListGroups200ResponseItemsInner
     */
    accessUserNames: Array<string>;
    /**
     * 作成日時
     * @type {Date}
     * @memberof ListGroups200ResponseItemsInner
     */
    createdAt: Date;
    /**
     * 更新日時
     * @type {Date}
     * @memberof ListGroups200ResponseItemsInner
     */
    updatedAt: Date;
    /**
     * 紐付けされた会社数
     * @type {number}
     * @memberof ListGroups200ResponseItemsInner
     */
    companyCount: number;
    /**
     * 
     * @type {Array<ListGroups200ResponseItemsInnerAllOfCompaniesInner>}
     * @memberof ListGroups200ResponseItemsInner
     */
    companies: Array<ListGroups200ResponseItemsInnerAllOfCompaniesInner>;
    /**
     * バージョン番号（PG）
     * @type {number}
     * @memberof ListGroups200ResponseItemsInner
     */
    version: number;
}


/**
 * @export
 */
export const ListGroups200ResponseItemsInnerBankAccountTypeEnum = {
    NORMAL: 1,
    CURRENT: 2
} as const;
export type ListGroups200ResponseItemsInnerBankAccountTypeEnum = typeof ListGroups200ResponseItemsInnerBankAccountTypeEnum[keyof typeof ListGroups200ResponseItemsInnerBankAccountTypeEnum];


/**
 * Check if a given object implements the ListGroups200ResponseItemsInner interface.
 */
export function instanceOfListGroups200ResponseItemsInner(value: object): value is ListGroups200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('accessUserNames' in value) || value['accessUserNames'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('companyCount' in value) || value['companyCount'] === undefined) return false;
    if (!('companies' in value) || value['companies'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function ListGroups200ResponseItemsInnerFromJSON(json: any): ListGroups200ResponseItemsInner {
    return ListGroups200ResponseItemsInnerFromJSONTyped(json, false);
}

export function ListGroups200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListGroups200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentGroupName': json['payment_group_name'] == null ? undefined : json['payment_group_name'],
        'organizationCode': json['organization_code'] == null ? undefined : json['organization_code'],
        'companyName': json['company_name'] == null ? undefined : json['company_name'],
        'invoiceNo': json['invoice_no'] == null ? undefined : json['invoice_no'],
        'addressName': json['address_name'] == null ? undefined : json['address_name'],
        'bankName': json['bank_name'] == null ? undefined : json['bank_name'],
        'branchName': json['branch_name'] == null ? undefined : json['branch_name'],
        'branchNum': json['branch_num'] == null ? undefined : json['branch_num'],
        'bankAccountType': json['bank_account_type'] == null ? undefined : json['bank_account_type'],
        'bankAccountNumber': json['bank_account_number'] == null ? undefined : json['bank_account_number'],
        'bankAccountName': json['bank_account_name'] == null ? undefined : json['bank_account_name'],
        'notificationMails': json['notification_mails'] == null ? undefined : json['notification_mails'],
        'accessMails': json['access_mails'] == null ? undefined : json['access_mails'],
        'note': json['note'] == null ? undefined : json['note'],
        'id': json['id'],
        'accessUserNames': json['access_user_names'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'companyCount': json['company_count'],
        'companies': ((json['companies'] as Array<any>).map(ListGroups200ResponseItemsInnerAllOfCompaniesInnerFromJSON)),
        'version': json['version'],
    };
}

export function ListGroups200ResponseItemsInnerToJSON(json: any): ListGroups200ResponseItemsInner {
    return ListGroups200ResponseItemsInnerToJSONTyped(json, false);
}

export function ListGroups200ResponseItemsInnerToJSONTyped(value?: ListGroups200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_group_name': value['paymentGroupName'],
        'organization_code': value['organizationCode'],
        'company_name': value['companyName'],
        'invoice_no': value['invoiceNo'],
        'address_name': value['addressName'],
        'bank_name': value['bankName'],
        'branch_name': value['branchName'],
        'branch_num': value['branchNum'],
        'bank_account_type': value['bankAccountType'],
        'bank_account_number': value['bankAccountNumber'],
        'bank_account_name': value['bankAccountName'],
        'notification_mails': value['notificationMails'],
        'access_mails': value['accessMails'],
        'note': value['note'],
        'id': value['id'],
        'access_user_names': value['accessUserNames'],
        'created_at': ((value['createdAt']).toISOString()),
        'updated_at': ((value['updatedAt']).toISOString()),
        'company_count': value['companyCount'],
        'companies': ((value['companies'] as Array<any>).map(ListGroups200ResponseItemsInnerAllOfCompaniesInnerToJSON)),
        'version': value['version'],
    };
}

